import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const HelpContext = createContext();

export const HelpProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [helpContent, setHelpContent] = useState(null);
    const location = useLocation();

    // Close help drawer on route change
    useEffect(() => {
        setIsOpen(false);
    }, [location.pathname]);

    const toggleHelp = () => setIsOpen(!isOpen);
    const closeHelp = () => setIsOpen(false);

    return (
        <HelpContext.Provider value={{ isOpen, toggleHelp, closeHelp, helpContent, setHelpContent }}>
            {children}
        </HelpContext.Provider>
    );
};

export const useHelpContext = () => {
    const context = useContext(HelpContext);
    if (!context) {
        throw new Error('useHelpContext must be used within a HelpProvider');
    }
    return context;
};

export const usePageHelp = (Component) => {
    const { setHelpContent } = useHelpContext();

    useEffect(() => {
        if (Component) {
            setHelpContent(() => Component);
        }
        return () => {
            setHelpContent(null);
        };
    }, [Component, setHelpContent]);
};
